import React, { useState, useEffect } from 'react';
import AuthContainer from '../_components/AuthContainer';
import { Box, Button, CircularProgress, FormControl, Typography, withStyles } from "@material-ui/core";
import { setCookieNew, deleteTokens, getCookie, getUrlParamValue } from "../_helpers/cookies";
import InputPaper from "../_components/InputPaper";
import config from "../_config/config";
import strings from "../_constants/strings";
import axios from "../_helpers/interceptor";
import styles from "../commonStyles";
import CommonPopup from '../_components/CommonPopup';
import { goToLogin, goBackToReferer } from '../_helpers/navHelpers';
import { connect } from 'react-redux';
import ResendButton from '../ForgotPassword/ResendButton';
import { Event } from '../_components/Event';
import { CssOutlinedInput } from '../_components/Input';

function TOTP(props) {
  const { classes, history, user, vendor } = props;
  const {
    TITLES: { TOTP, OTP },
    MESSAGES: { ENTER_TOTP_INFO, ENTER_OTP_INFO },
    LABELS: { SUBMIT, LOGIN_WITH_OTP, LOGIN_WITH_TOTP },
    ERRORS: { E_TOTP, E_OTP, E_TOTP_LENGTH, E_OTP_LENGTH }
  } = strings;

  const [errorObj, setErrorObj] = useState({ error: '', submitting: false, message: '' });
  const [errorPopup, setErrorPopup] = useState({ open: false, message: '' });
  const [otp, setOtp] = useState('');
  const [isTotp, setIsTotp] = useState(false);
  const [otpToken, setOtpToken] = useState(null);

  const otpSuccessEvent = new Event("OTP_SUCCESS");

  useEffect(() => {
    if (user) {
      setIsTotp(user.totpFlag || false)
      if (!user?.totpFlag) {
        sendOtp()
      }
    }
  }, [])

  function sendOtp() {
    axios.post(vendor ? `${config.algoendpoint}${config.algosendOtp}` : `${config.endpoint}${config.sendOtp}`,
      { payload: [{ product: "OTP2FA", ...(vendor ? { logintoken: user.logintoken } : {}) }] }, { headers: { Authorization: `Bearer ${user?.access_token || ''}` } }).then(response => {
        const { data: { success, error } } = response;
        if (success) {
          // setErrorPopup({ open: true, message: success?.msg || '' })
          setErrorObj({ success: true, message: success?.msg || '' })
          setOtpToken(success?.otpToken || null)
          setTimeout(() => {
            otpSuccessEvent.sendMessage();
          }, 100)
        } else {
          setErrorPopup({ open: true, message: error?.msg || '' })
          error.errorCode && error.errorCode === 1502 && setOtpToken(null)
        }
      }).catch((error) => {
        setErrorPopup({ open: true, message: error?.error || 'Something went wrong' })
        // setOtpToken(null)
      });
  }

  function resendOtp() {
    axios.post(vendor ? `${config.algoendpoint}${config.algoresendotp}` : `${config.endpoint}${config.resendotp}`, { payload: [{ otpToken }] }, { headers: { Authorization: `Bearer ${user?.access_token || ''}` } }).then(response => {
      const { data: { success, error, errorCode } } = response;
      if (success) {
        setErrorObj({ success: true, message: success?.msg || '' })
        setTimeout(() => {
          otpSuccessEvent.sendMessage();
        }, 100)
      } else {
        const { error_description } = error;
        setErrorPopup({ open: true, message: error_description || error.error || (typeof (error) === 'string' ? error : 'Something went wrong') })
        errorCode && errorCode === 1753 && setOtpToken(null)
      }
    }).catch((error) => {
      setErrorPopup({ open: true, message: error?.error || 'Something went wrong' })
      // setOtpToken(null)
    });
  }

  useEffect(() => {
    if (otp?.length === 6) {
      handleOtpSubmit()
    }
  }, [otp])

  const handleOtpSubmit = (e) => {
    e && e.preventDefault();
    if (otp?.length === 6) {
      setErrorObj({ submitting: true });
      let dt = {
        payload: [{
          otp: otp,
          authFlag: isTotp ? "1" : "0",
          ...(vendor ? { logintoken: user?.logintoken || "" } : {})
        }]
      }
      axios.post(vendor ? `${config.algoendpoint}${config.algologinWithTOTP}` : `${config.endpoint}${config.loginWithTOTP}`, dt, { headers: { Authorization: `Bearer ${user?.access_token || ''}` } }).then((response) => {
        const { data: { success, error } } = response;
        if (success) {
          deleteTokens();
          setCookieNew('t_token', vendor ? success?.access_token : user?.access_token);
          setCookieNew('t_refresh_token', vendor ? success?.refresh_token : user?.refresh_token)
          setCookieNew("totp", user?.totpFlag ? 1 : 0)
          setCookieNew("showBanner", "Yes")
          if (vendor) {
            // deleteTokens();
            // setCookieNew('t_token', success?.access_token);
            // setCookieNew('t_refresh_token', success?.refresh_token)
            // setCookieNew("totp", user?.totpFlag ? 1 : 0)
            window.location.href = atob(getCookie('referer')) + `?token=${btoa(success?.access_token || '')}&state=${getUrlParamValue('state') || ''}`
          } else {
            setCookieNew("totp", user?.totpFlag ? 1 : 0)
            goBackToReferer(window)
          }
        }
        if (error) {
          const { error_description } = error;
          setErrorPopup({ open: true, message: error_description || error.error })
        }
      }).catch((err) => {
        const { error } = err?.data || {};
        const { error_description } = error || {};
        setErrorObj({ error: true, message: error_description || 'Something went wrong' })
      });
    } else {
      setOtp(null)
    }
  };

  function handleKeyPress(e) {
    if (errorObj?.error) {
      setErrorObj({ error: false, message: '' })
    }
    var char = e.target.value.replace(/[^0-9]/g, '');
    setOtp(char)
  }

  function handlePopup() {
    if (!otpToken) {
      goToLogin(history);
      return;
    }
    setErrorPopup({ open: false, message: '' })
    // otpSuccessEvent.sendMessage();
  }

  function handleLoginWithOtpLink(e) {
    e && e.preventDefault();
    // gotoLoginWithOtp(history, username);
    setOtp('')
    setIsTotp(!isTotp)
    isTotp && sendOtp()
    errorObj.error && setErrorObj({ error: false, message: '' })
  };

  function onExceed() {
    alert("Resend attempts exceeded, kindly start over...");
    goToLogin(history);
  };

  return (
    <AuthContainer formtype="enter totp">
      <Box className={classes.formBox} style={{ height: "100%" }}>
        <div style={{ width: "100%" }}>
          <Typography gutterBottom className={classes.formtitle}>
            {isTotp ? TOTP : OTP}
          </Typography>

          {/* <InputPaper
            autoFocus
            inputtype="password"
            value={otp}
            name={isTotp ? "Enter totp" : "Enter otp"}
            placeholder={isTotp ? "Enter TOTP" : "Enter OTP"}
            handler={handleKeyPress}
            image="../images/lockicon.svg"
            alt_text="lock-icon"
            errorPos='top'
            onChange={handleKeyPress}
            errorMsg={otp === null ?
              isTotp ? E_TOTP : E_OTP :
              (otp && (otp.length < 6 || otp.length > 6)) ?
                isTotp ? E_TOTP_LENGTH : E_OTP_LENGTH
                : null}
            disabled={errorObj?.submitting}
          /> */}

          <Typography
            className={classes.infomsg}
            variant="caption"
            display="block"
            gutterBottom
          >
            {isTotp ? ENTER_TOTP_INFO : errorObj?.success ? errorObj.message : ''}
          </Typography>

          <FormControl className={classes.formControl}>
            <CssOutlinedInput
              id="otp"
              type={'text'}
              fullWidth
              value={otp}
              onChange={handleKeyPress}
              name={isTotp ? "Enter totp" : "Enter otp"}
              placeholder={isTotp ? "Enter TOTP" : "Enter OTP"}
              variant="outlined"
              disabled={errorObj?.submitting}
              autoFocus
              error={errorObj?.error ? true : false}
              inputProps={{
                'aria-label': 'OTP',
              }}
            />
            <Typography variant="body2" className={classes.errorText}>
              {otp === null ?
                isTotp ? E_TOTP : E_OTP :
                (otp && (otp.length < 6 || otp.length > 6)) ?
                  isTotp ? E_TOTP_LENGTH : E_OTP_LENGTH
                  : null}
            </Typography>
          </FormControl>
          {!isTotp && <div style={{float: "right"}}>
            <ResendButton
              noAutoStart={true}
              timeOut={60}
              // resendLimit={3}
              onClick={resendOtp}
              onExceed={onExceed}
            />
          </div>}
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <Typography
            className={classes.errormsg}
            variant="caption"
            display="block"
            gutterBottom
          >
            {errorObj?.error ? errorObj.message : ''}
          </Typography>
          <Button
            variant="contained"
            className={classes.blueButton}
            type="submit"
            onClick={handleOtpSubmit}
            disabled={errorObj?.submitting}
          >
            {SUBMIT}
            {errorObj?.submitting ? <CircularProgress size="15" className={classes.spinner} /> : <></>}
          </Button>
          {!(user?.totpFlag) ? <></> : <a
            href=""
            className={classes.loginwithotp}
            style={{ paddingTop: "12px" }}
            onClick={handleLoginWithOtpLink}
          >
            {isTotp ? LOGIN_WITH_OTP : LOGIN_WITH_TOTP}
          </a>}
        </div>
        {errorPopup?.open &&
          <CommonPopup
            openState={errorPopup.open}
            popupText={errorPopup.message || ''}
            handleClick={handlePopup}
          />}
      </Box>
    </AuthContainer>
  )
}

function mapStateToProps(state) {
  const { authentication: { user }, logintype } = state;
  return { user, vendor: logintype?.vendor || false };
}

export default connect(mapStateToProps)(withStyles(styles)(TOTP));